import axios from 'axios'

// Dedicated client for the agent portal (agents.logeco.africa), realm 'agent',
// isolated from the admin and partner axios instances.
const agent = axios.create({
  baseURL: process.env.VUE_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
})

export const AGENT_TOKEN_KEY = 'agentToken'

agent.interceptors.request.use((config) => {
  if (config.data instanceof FormData) delete config.headers['Content-Type']
  const token = localStorage.getItem(AGENT_TOKEN_KEY)
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})

agent.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error.config?.url || ''
    const isAuth = url.includes('/agent/auth/login')
    if (error.response?.status === 401 && !isAuth) {
      localStorage.removeItem(AGENT_TOKEN_KEY)
      window.location.href = '/agent/login'
    }
    return Promise.reject(error)
  }
)

export function setAgentToken(token) {
  if (token) localStorage.setItem(AGENT_TOKEN_KEY, token)
  else localStorage.removeItem(AGENT_TOKEN_KEY)
}

export const agentAuthAPI = {
  login: (email, password) => agent.post('/agent/auth/login', { email, password }),
  changePassword: (currentPassword, newPassword) => agent.post('/agent/auth/change-password', { currentPassword, newPassword }),
}

function ingest(entity) {
  return {
    ingestPreview: (data) => agent.post(`/agent/${entity}/ingest/preview`, data),
    ingestCommit: (data) => agent.post(`/agent/${entity}/ingest/commit`, data),
  }
}

export const agentAPI = {
  me: () => agent.get('/agent/me'),
  submissions: () => agent.get('/agent/submissions'),
  opportunityTypes: () => agent.get('/agent/opportunity-types'),
  opportunities: ingest('opportunities'),
  schools: ingest('schools'),
  guides: ingest('guides'),
}

export default agent
